// Generated by CoffeeScript 2.3.2

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { Component } from 'react';
;
var ConfirmDialog,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } };

ConfirmDialog = class ConfirmDialog extends Component {
  constructor() {
    super(...arguments);
    this.handleYes = this.handleYes.bind(this);
    this.handleNo = this.handleNo.bind(this);
  }

  handleYes() {
    boundMethodCheck(this, ConfirmDialog);
    if (this.props.yesAction != null) {
      this.props.yesAction();
    }
    this.props.onClose();
  }

  handleNo() {
    boundMethodCheck(this, ConfirmDialog);
    if (this.props.noAction != null) {
      this.props.noAction();
    }
    this.props.onClose();
  }

  render() {
    var noAction, open, question, title, yesAction;
    ({open, title, question, yesAction, noAction} = this.props);
    return <Dialog disableBackdropClick={true} disableEscapeKeyDown={true} open={open} onClose={this.handleNo}>
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {question}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {(noAction != null ? <Button variant="contained" color="primary" onClick={this.handleNo}>{(yesAction != null ? "No" : "Cancel")}</Button> : void 0)}
        {((yesAction != null) || !noAction ? <Button variant="contained" color="primary" onClick={this.handleYes}>{(noAction != null ? "Yes" : "Ok")}</Button> : void 0)}
      </DialogActions>
    </Dialog>;
  }

};

export default ConfirmDialog;
